import { useEffect, useRef } from 'react';
import { ColorMap } from '@fabric-web/3d-viewer';

export const useColorMap = (
  maxId: number,
  colors?: Map<number, number> | undefined,
  defaultColor?: number | undefined
) => {
  const colorMap = useRef<ColorMap>(new ColorMap(maxId, colors, defaultColor));

  useEffect(() => {
    const { current } = colorMap;
    return () => {
      current.texture.dispose();
    };
  }, [colorMap]);

  return colorMap.current;
};
